export default {"src":"/_next/static/image/src/images/SocialMediaIcons/spotify.e1e5f11ffcdc96ba374761d51a50e003.svg","height":24,"width":25};